import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faRoute, faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { DeliveryEntity } from "../../../Objects/DeliveryEntity/DeliveryEntity"
import { countRouteRelevantDeliveries } from "../../../hooks/Delivery/deliveryListUtils"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"

interface Props {
  deliveries: DeliveryEntity[]
  onOpen: () => void
}

export function CourierRoutePlanBanner({ deliveries, onOpen }: Props) {
  const { t } = useTranslation("frontend")

  const routeRelevantCount = useMemo(() => countRouteRelevantDeliveries(deliveries), [deliveries])

  if (routeRelevantCount < 2) {
    return null
  }

  return (
    <Animate type={AnimationTypes.fadeInTraslate}>
      <button
        type="button"
        onClick={onOpen}
        className="flex w-full items-center justify-between gap-3 rounded-2xl bg-gradient-to-r from-orange-500 via-red-500 to-red-600 p-4 text-left shadow-lg ring-2 ring-orange-200 transition-transform active:scale-[0.98]"
        data-interaction-description-key="interactionDescriptions:pages.delivery.components.courierRoutePlanBanner.button.onOpen"
      >
        <div className="flex min-w-0 items-center gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/20">
            <FontAwesomeIcon icon={faRoute} className="text-xl text-white" />
          </div>

          <div className="min-w-0">
            <p className="truncate text-[10px] font-black uppercase tracking-wider text-orange-100">
              {t("route_plan.banner_eyebrow")}
            </p>

            <p className="truncate text-base font-black text-white">{t("route_plan.banner_title")}</p>

            <p className="truncate text-xs font-semibold text-orange-50">
              {t("route_plan.banner_subtitle", { count: routeRelevantCount })}
            </p>
          </div>
        </div>

        <FontAwesomeIcon icon={faChevronRight} className="shrink-0 text-lg text-white" />
      </button>
    </Animate>
  )
}
